import React from 'react';
import styled from 'styled-components';
import DataTableHeaders from '@/containers/DataTableHeaders';
import css from '@/css/module/new-world.css';
import { useHeadings_LEGACY } from '@/features/query-builder/hooks/LEGACY';

const Table = styled.table.attrs({
  className: 'data-table',
})`
  margin-bottom: 0;
`;

export const Header: React.FC<{
  headerRef: React.RefObject<HTMLDivElement>;
}> = ({ headerRef }) => {
  const headings = useHeadings_LEGACY();

  return (
    <div ref={headerRef} className={css.tableHeaders}>
      <Table>
        <tbody>
          {headings && (
            <DataTableHeaders
              isFixedHeader
              key={`dtHeaderFixed${0}`}
              rowIndex={0}
              headings={headings}
              hasOptions
            />
          )}
        </tbody>
      </Table>
    </div>
  );
};
